import { graphql } from '@/gql'

export const GetJobSharesQuery = graphql(/* GraphQL */ `
  query JobShares($jobId: ID!, $first: Int) {
    job(id: $jobId) {
      company {
        settings {
          staffingAgencyManagesWorker
        }
      }
      shares(isActive: true, accountTypes: [WORKER, RECRUITER, COMPANY], first: $first) {
        data {
          ... on JobShare {
            id
            account {
              ...JobFormShareableWorker
              ...JobFormShareableRecruiter
              ...JobFormShareableCompany
            }
          }
        }
      }
    }
  }
`)
